import React from "react";

export const FsmPrivacyPolicyPage: React.FC = () => {
  const email = "infofsm@libero.it";
  const associationName = "Societa Sportiva FSM";
  const address = "Via Monsignor Dino Torreggiani, 10, Reggio Emilia, Italia";

  return (
    <div className="min-h-screen flex justify-center">
      <div className="bg-white rounded-2xl shadow-md p-8 max-w-3xl w-full">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Privacy & Cookie Policy
        </h1>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">1. Titolare del trattamento</h2>
          <p>
            Il titolare del trattamento dei dati e <strong>{associationName}</strong>,
            con sede in <strong>{address}</strong>. Contatto email:{" "}
            <strong>{email}</strong>.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">2. Tipologie di dati raccolti</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Dati anagrafici (nome, cognome)</li>
            <li>Dati di contatto (email)</li>
            <li>Credenziali di accesso (password criptata)</li>
            <li>Dati relativi a partecipazione a tornei e classifiche</li>
          </ul>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">3. Finalita del trattamento</h2>
          <p>
            I dati vengono trattati esclusivamente per la gestione degli account
            utente, dei tornei, delle classifiche e per eventuali comunicazioni
            legate all'attivita della piattaforma.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">4. Cookie Policy</h2>
          <p>
            Questo sito utilizza <strong>solo cookie tecnici</strong>, necessari al
            funzionamento della piattaforma (es. autenticazione e sessione).
            Non vengono utilizzati cookie di profilazione o di terze parti a fini di
            marketing.
          </p>
          <p className="mt-2">
            L'utente puo disattivare i cookie tramite il browser, ma alcune
            funzionalita della piattaforma potrebbero non funzionare correttamente.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold mb-2">5. Diritti degli utenti</h2>
          <p>
            Gli utenti possono richiedere in qualsiasi momento l'accesso, la rettifica,
            la cancellazione o la portabilita dei propri dati, oltre a limitare o
            opporsi al trattamento. Le richieste vanno inviate a{" "}
            <strong>{email}</strong>.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-2">6. Modifiche</h2>
          <p>
            Il titolare si riserva il diritto di modificare la presente policy.
            Le modifiche saranno pubblicate su questa pagina.
          </p>
        </section>
      </div>
    </div>
  );
};
